<style scoped>
.productImg {
  width: 60%;
  margin: 0 20%;
  position: relative;
  height: 400px;
  object-fit: contain;
}
.discountedPrice {
  text-decoration: line-through;
  color: gray !important;
}
.ribbon {
  background: linear-gradient(#f70505 0%, #8f0808 100%);
  height: 87px;
  margin: 0 auto;
  position: absolute;
  width: 74px;
  right: 50px;
  text-align: center;
  vertical-align: middle;
  line-height: 75px;
  font-weight: 800;
  color: #f2f2f2;
  z-index: 2;
}
.ribbon:after,
.ribbon:before {
  content: '';
  position: absolute;
  border-top: 20px solid #8f0808;
  height: 0;
  width: 0;
  top: 100%;
}
.ribbon:after {
  border-left: 50px solid transparent;
  right: 0px;
}
.ribbon:before {
  border-right: 50px solid transparent;
  left: 0px;
}
.img-container {
  position: relative;
}
.posRibbon {
  position: absolute;
}
.off {
  margin-top: -60px;
  font-size: 15px !important;
  font-weight: 700;
}
.disPrice {
  font-weight: 900;
  font-size: 1.4rem;
}
.price {
  font-weight: bold;
  font-size: 1.4rem;
}
.upwrd {
  z-index: 2;
}

.ribbonSml {
  background: linear-gradient(#f70505 0%, #8f0808 100%);
  height: 38px;
  margin: 0 auto;
  position: absolute;
  width: 50px;
  right: 10px;
  text-align: center;
  vertical-align: middle;
  line-height: 35px;
  font-weight: 700;
  color: #f2f2f2;
}
.ribbonSml:after,
.ribbonSml:before {
  content: '';
  position: absolute;
  border-top: 20px solid #8f0808;
  height: 0;
  width: 0;
  top: 100%;
}
.ribbonSml:after {
  border-left: 50px solid transparent;
  right: 0px;
}
.ribbonSml:before {
  border-right: 50px solid transparent;
  left: 0px;
}
.offSml {
  margin-top: -20px;
  font-size: 15px !important;
  font-weight: 700;
}
.posAbsolut {
  position: absolute;
  z-index: 2;
  top: 10px;
  left: 10px;
}
.smalltxt {
  font-size: 8px;
}
.txt18px {
  font-size: 18px !important;
}
.mt120 {
  margin-top: 120px;
}
.card {
  background: #ffffff;
  -webkit-box-shadow: 0px 10px 40px rgb(0 0 0 / 5%) !important;
  box-shadow: 0px 10px 40px rgb(0 0 0 / 5%) !important;
  border-radius: 5px;
  min-width: 136px;
}
.card .card-image img {
  height: 120px;
  object-fit: contain;
}
#satescheduleholder {
  display: none;
}
.paginate-panel {
  display: flex;
  justify-content: flex-end;
}
.paginate-panel > ul.paginate-links.product {
  display: flex;
  align-items: center;
}
.paginate-panel > ul.paginate-links.product > li {
  margin: 0 10px;
  cursor: pointer;
}
.paginate-panel > ul.paginate-links.product > li a {
  color: #000;
}
.paginate-panel > ul.paginate-links.product > li.disabled a {
  color: gray;
}
.paginate-panel > ul.paginate-links.product > li.number.active {
  background: #b70033 !important;
  width: 22px !important;
  height: 22px !important;
  text-align: center !important;
  border-radius: 50% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.paginate-panel > ul.paginate-links.product > li.number.active a {
  color: white !important;
}
.card .card-content {
  padding: 20px 0;
  border-radius: 0 0 2px 2px;
}
p.truncate.txt-12 {
    font-size: 15px !important;
    padding: 0 15px;
}
</style>
<template lang="pug">
div
  app-delivery-bar(:fixed='true', :top='"64px"')
  .container.mt120(v-if='user && selectedVariant')
    .vspace.large
    .row
      .col.m6.s12
        .img-container
          .ribbon(
            v-if='user && selectedVariant.discounted.length && new Date(selectedVariant.discounted[0].end) > new Date()'
          )
            span(
              v-if='selectedVariant.discounted[0].discountType === "percent"'
            ) {{ selectedVariant.discounted[0].amount }} %
            span(v-else)
              span.smalltxt PHP
              span.txt18px {{ selectedVariant.discounted[0].amount }}
            p.off OFF
          img.productImg(:src='selectedVariant.photo')
      .col.m6.s12
        p.title.medium {{ singleproduct.name }}
        .section.bordered.light-gray
          .row
            .col.s12.m6
              p.subtitle Bottler
              p.title.no-margin-top {{ singleproduct.bottler }}

            .col.s12.m6
              p.subtitle Country
              p.title.no-margin-top {{ singleproduct.country }}

            .col.s12.m6
              p.subtitle Region
              p.title.no-margin-top {{ singleproduct.region }}

            .col.s12.m6
              p.subtitle Essence
              p.title.no-margin-top {{ singleproduct.essence }}
        p.title.medium.truncate {{ selectedVariant.variantCode }}
        .row
          .col.s12.m6
            p.subtitle Volume
            p.title.no-margin-top {{ selectedVariant.volumeCl ? selectedVariant.volumeCl + "cl" : "Unavailable" }}
          .col.s12.m6
            p.subtitle Alcohol Content
            p.title.no-margin-top {{ selectedVariant.alcoholContent ? selectedVariant.alcoholContent + "%" : "Unavailable" }}
          .col.s12.m6
            p.subtitle Age
            p.title.no-margin-top {{ selectedVariant.age ? selectedVariant.age + " years" : "Unavailable" }}
        input#satescheduleholder(type='text', ref='datepicker')
        div(v-if='user')
          div
            div(v-if='ifdiscountvalid')
              p.title.green-text(
                v-bind:class='selectedVariant.discounted.length ? onSaleClass : ""'
              ) {{ $utils.formatter.formatAmount(selectedVariant.price) }}
              p.title.red-text.disPrice {{ $utils.formatter.formatAmount(discountValue) }}
            div(v-else)
              p.title.green-text.price {{ $utils.formatter.formatAmount(selectedVariant.price) }}
          //- Reseller can only purchase conventional
          div(v-if='user.type === "reseller"')
            div(v-if='singleproduct.tags === "conventional"')
              div(v-if='selectedVariant.availableStock > 0')
                .row.mt-5
                  .col.s12.m6.mt-lg-0.mt-5
                    .btn-compound.bordered.width100(
                      :class='{ disabled: !canAddToCart }'
                    )
                      a.btn-compound-item.waves-effect(
                        @click='quantity--',
                        :class='quantity === 1 ? "disabled" : ""'
                      )
                        i.material-icons remove
                      span.btn-compound-item.grow.center-align {{ quantity }}
                      a.btn-compound-item.waves-effect(@click='quantity++')
                        i.material-icons add

                  .col.s12.m6.mt-lg-0.mt-5
                    a.btn.width100.waves-effect(
                      @click='addToCart',
                      :class='{ disabled: !canAddToCart }'
                    ) Add to Cart
              div(v-else)
                div
                  p.title.small.red-text OUT OF STOCK

            div(v-else)
              p.title.small You are currently logged in as a reseller, you can&apos;t purchase this item.
              a.indigo-text(@click='logout') Log-in or register as a Shopper
          //- for Shopper can oly purchase The Scotch Malt Whisky Society item
          div(v-else)
            div(v-if='singleproduct.tags === "The Scotch Malt Whisky Society"')
              div(v-if='selectedVariant.availableStock > 0')
                //- .row
                //-   .col.s12.mb-5
                //-     p.subtitle.light Choose delivery schedule
                //- .row
                //-   .col.s12(v-for='schedule in availableSchedules')
                //-     span
                //-       label
                //-         input.with-gap(
                //-           type='radio',
                //-           v-model='selectedSchedule',
                //-           :value='schedule.type',
                //-           @change='onDeliveryChange'
                //-         )
                //-         span(v-if='schedule.type === "same_day"') For Today
                //-         span(v-else-if='schedule.type === "range"') {{  schedule.value.split(';')[0] + " - " + schedule.value.split(';')[1] + " business days"  }}
                //-         span(v-else-if='schedule.type === "scheduled"') Scheduled {{ deliveryDateSelected }}
                .row.mt-5
                  .col.s12.m6.mt-lg-0.mt-5
                    .btn-compound.bordered.width100(
                      :class='{ disabled: !canAddToCart }'
                    )
                      a.btn-compound-item.waves-effect(
                        @click='quantity--',
                        :class='quantity === 1 ? "disabled" : ""'
                      )
                        i.material-icons remove
                      span.btn-compound-item.grow.center-align {{ quantity }}
                      a.btn-compound-item.waves-effect(@click='quantity++')
                        i.material-icons add

                  .col.s12.m6.mt-lg-0.mt-5
                    a.btn.width100.waves-effect(
                      @click='addToCart',
                      :class='{ disabled: !canAddToCart }'
                    ) Add to Cart
              div(v-else)
                div
                  p.title.small.red-text OUT OF STOCK
            div(v-else)
              p.title.small You are currently logged in as a Membership Shopper, you can&apos;t purchase this item.
              a.indigo-text(@click='logout') Log-in or register as Reseller
        div(v-else)
          p.title.small You have to be logged in to view the prices nor buy the item
          a.indigo-text(@click='logout') Log-in or register
          //- router-link.indigo-text(
          //-   :to='{ path: "login", query: { redirectUrl: $route.path } }'
          //- ) Log-in or register
    p.title.medium Other {{ singleproduct.name }} Variants
      paginate.mt-5(name='product', :list='product', :per='12')
        .row
          .col-lg-3.col-6.s6.m3.l2(v-for='(pvariants, index) in paginated("product")')
            .card(@click='selectOtherVariant(pvariants)')
              .ribbonSml.upwrd(
                v-if='user && pvariants.discounted.length && new Date(pvariants.discounted[0].end) > new Date()'
              )
                span(
                  v-if='pvariants.discounted[0].discountType === "percent"'
                ) {{ pvariants.discounted[0].amount }} %
                span(v-else)
                  span.smalltxt PHP
                  span {{ pvariants.discounted[0].amount }}
                p.offSml OFF

              .card-image.imgsize
                i.material-icons.selection-indicator.green-text.posAbsolut(
                  v-if='pvariants.variantCode == selectedVariant.variantCode'
                ) check_circle
                img(:src='pvariants.photo')
              .card-content
                p.truncate.txt-12 {{ pvariants.variantCode }}
    .paginate-panel(v-if='product.length > 12')
      paginate-links(for='product', :limit='4', :show-step-links='true')
</template>
<script>
import dateformat from 'dateformat'
import axios from 'axios'
import AppDeliveryBar from '@/components/app-delivery-bar'

export default {
  meta: {
    title: 'Drinks',
  },
  data() {
    return {
      onSaleClass: 'discountedPrice',
      product: null,
      selectedVariant: null,
      schedules: [],
      quantity: 1,
      deliverySchedule: null,
      selectedSchedule: null,
      giftWrapped: false,
      newPs: null,
      deliveryDateSelected: null,
      paginate: ['product'],
      singleproduct: {},
    }
  },
  created() {
    // this.getProduct(
    //   this.singleproduct.shop.code,
    //   this.singleproduct.productCode
    // )
    this.getProduct(
      this.$route.params.shopCode,
      this.$route.params.productCode,
      this.$route.params.variantId
    )
  },
  mounted() {},
  computed: {
    discountValue() {
      if (
        this.ifdiscountvalid &&
        this.selectedVariant.discounted.length &&
        this.selectedVariant.discounted[0].discountType === 'fix'
      ) {
        return (
          this.selectedVariant.price - this.selectedVariant.discounted[0].amount
        )
      } else if (
        this.ifdiscountvalid &&
        this.selectedVariant.discounted.length &&
        this.selectedVariant.discounted[0].discountType === 'percent'
      ) {
        return (
          this.selectedVariant.price -
          (this.selectedVariant.discounted[0].amount / 100) *
            this.selectedVariant.price
        )
      } else {
        return this.selectedVariant.price
      }
    },
    ifdiscountvalid() {
      if (this.selectedVariant.discounted.length) {
        let endDate = this.selectedVariant.discounted[0].end
        let CurrentDate = new Date()
        endDate = new Date(endDate)

        if (endDate > CurrentDate) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    UpdatedSelectedVariant() {
      let variantDrink
      variantDrink = {
        id: this.selectedVariant.id,
        variantCode: this.selectedVariant.variantCode,
        price: this.discountValue,
        availableStock: this.selectedVariant.availableStock,
      }
      return variantDrink
    },
    user() {
      // return this.$store.state.user
      return this.$store.state.auth.user
    },
    // singleproduct() {
    //   return this.$route
    //     ? this.$route.params.singleproduct
    //     : // ? this.$route.query.myprop
    //       null
    // },
    canAddToCart() {
      return (
        // this.selectedVariant && this.selectedVariant.availableStock > 0 && this.deliverySchedule
        this.selectedVariant && this.selectedVariant.availableStock > 0
      )
    },
    availableSchedules() {
      if (!this.schedules.length) {
        return []
      }

      return this.schedules
        .map((schedule) => {
          return {
            type: schedule.propertyType.split(':')[2],
            value: schedule.propertyValue,
          }
        })
        .sort((a, b) => {
          if (a.type === 'scheduled') {
            return 1
          }
          return 0
        })
    },
  },
  watch: {},
  methods: {
    isForReseller(user, product) {
      if (user.type === 'reseller') {
        if (product.tags === 'conventional') {
          return true
        } else {
          return false
        }
      } else if (user.type === 'customer') {
        if (product.tags === 'The Scotch Malt Whisky Society') {
          return false
        } else {
          return true
        }
      }
    },
    selectOtherVariant(pvariants) {
      this.selectedVariant = pvariants
    },
    onDeliveryChange() {
      this.deliverySchedule = this.selectedSchedule
      this.deliveryDate = null
      if (this.selectedSchedule === 'scheduled') {
        this.$M.Datepicker.init(this.$refs.datepicker, {
          minDate: new Date(),
          onSelect: this.onDateSelected,
          onClose: this.onNoDateSelected,
          showClearBtn: false,
        })
        this.$M.Datepicker.getInstance(this.$refs.datepicker).open()
      } else if (this.selectedSchedule === 'range') {
        this.availableSchedules.forEach((schedule) => {
          if (schedule.type === 'range') {
            this.deliverySchedule = this.selectedSchedule + ':' + schedule.value
          }
        })
      }
    },
    async onDateSelected(data) {
      this.deliveryDateSelected = dateformat(data, 'ddd, mmm dd')
      this.deliverySchedule =
        (await this.selectedSchedule) + ':' + dateformat(data, 'ddd, mmm dd')
    },
    onNoDateSelected() {},
    async getProduct(shopCode, productCode, variantId) {
      await axios
        .get(
          `${this.$config.API_URL}/products/${shopCode}/${encodeURI(
            productCode
          )}`
        )
        .then((res) => {
          this.product = res.data.variants
          this.singleproduct = res.data
          document.title = this.singleproduct.name + ' - Inom PH'
          // let itemfilterby = this.singleproduct.variant.variantCode
          let itemfilterby = parseInt(variantId)
          for (var i = 0; i < res.data.variants.length; i++) {
            if (res.data.variants[i]['id'] === itemfilterby) {
              this.selectedVariant = res.data.variants[i]
            }
          }
        })
        .then(() => {
          return this.getDeliverySchedules()
        })
        .catch((err) => {
          this.$snackbar.show({
            text: 'Oops, there seems to be a problem: ' + err.message,
          })
        })
    },
    getDeliverySchedules() {
      return this.$http
        .get(
          `${this.$config.API_URL}/suppliers/${this.singleproduct.supplier.id}/settings`
        )
        .then((settings) => {
          settings.data.forEach((setting) => {
            if (setting.propertyType.startsWith('delivery:schedule')) {
              this.schedules.push(setting)
            }
          })
        })
    },
    addToCart() {
      let product = {
        ...this.UpdatedSelectedVariant,
        parent: {
          id: this.singleproduct.id,
          code: this.singleproduct.productCode,
          name: this.singleproduct.name,
        },
        shop: {
          id: this.singleproduct.shop.id,
          code: this.singleproduct.shop.code,
          name: this.singleproduct.shop.name,
        },
        supplier: {
          id: this.singleproduct.supplier.id,
          code: this.singleproduct.supplier.code,
          name: this.singleproduct.supplier.name,
        },
      }
      this.$store
        .dispatch('cart/addToCart', {
          product: product,
          quantity: this.quantity,
          giftWrapped: this.giftWrapped,
          options: [
            {
              type: 'delivery:schedule',
              // value: this.deliverySchedule
              value: 'range:1;10',
            },
          ],
        })
        .then(() => {
          this.$emit('added')
        })
      this.$snackbar.success(this.singleproduct.name + ' added to cart')
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        localStorage.clear()
        this.$router.push({ path: '/login' })
      })
    },
  },
  components: {
    AppDeliveryBar,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-single-product.vue